import React, { useContext, ReactNode } from 'react';
import { Box, IconChevron, Text } from 'braid-design-system';

import * as styles from '../MenuGroup.css';
import MenuContext from './Context';

interface Props {
  text: string | ReactNode;
  leftIcon?: ReactNode;
}

const Title = ({ text, leftIcon }: Props) => {
  const { isExpanded, setIsExpanded } = useContext(MenuContext);

  return (
    <Box
      alignItems="center"
      cursor="pointer"
      display="flex"
      flexDirection="row"
      justifyContent="spaceBetween"
      onClick={() => setIsExpanded(!isExpanded)}
      padding="medium"
      {...(!isExpanded && { className: styles.menuGroupContainer })}
    >
      <Text weight={isExpanded ? 'strong' : 'regular'}>
        {leftIcon}
        {text}
      </Text>
      <IconChevron direction={isExpanded ? 'up' : 'down'} size="small" />
    </Box>
  );
};

export default Title;
